import { CloseCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import { Button, Modal } from 'antd';

import { accessCaseKeys } from '../data';

import { CaseViewPanel } from './panel';

export type CaseViewModalProps = {
  caseId?: number;
  onClose: () => void;
};

export const CaseViewModal = ({ caseId, onClose }: CaseViewModalProps) => {
  const queryClient = useQueryClient();

  const handleRefresh = async () => {
    if (!caseId) return;
    await queryClient.invalidateQueries({ queryKey: accessCaseKeys.detail(caseId) });
  };

  return (
    <Modal
      title="Case"
      centered
      width={900}
      styles={{
        body: {
          height: 500,
          overflow: 'auto',
        },
      }}
      open={!!caseId}
      onCancel={onClose}
      footer={[
        <Button key="refresh" onClick={handleRefresh} icon={<ReloadOutlined />}>
          Refresh
        </Button>,
        <Button key="close" onClick={onClose} icon={<CloseCircleOutlined />} type="primary">
          Close
        </Button>,
      ]}
    >
      {caseId ? <CaseViewPanel caseId={caseId} /> : undefined}
    </Modal>
  );
};
